import d3Logo from '../../assets/d3-logo.png';
import { authState } from '../../lib/auth.js';
import { BaseComponent } from '../../lib/base-component.js';
import { css, html, nothing } from '../../lib/lit.js';

// Shown when a visitor is signed in with a d3-auth session but that account has
// no access:staff — authenticated, but not a staff member. It replaces the
// cryptic "invalid or unauthorized token" 403 the app used to surface when it
// dropped a non-staff user straight into a gated view. The way out is to sign out
// and come back with a staff account, so the one action is logout (which also
// clears the session at d3-auth, letting them pick a different account).
class NotAuthorizedView extends BaseComponent {
    static properties = {
        email: { type: String },
    };

    static styles = css`
        .wrap {
            max-width: 30rem;
            margin: 0 auto;
            padding: 5rem 1rem;
            text-align: center;
        }
        .brand-logo {
            height: 3.5rem;
            width: auto;
        }
    `;

    render() {
        return html`
            <div class="wrap">
                <img class="brand-logo mb-3" src=${d3Logo} alt="Dice Driven" />
                <h1 class="h4 mb-3">Dice Driven Staff</h1>
                <p class="mb-1"><strong>This account isn't authorized for the staff console.</strong></p>
                <p class="text-muted mb-4">
                    ${
                        this.email
                            ? html`You're signed in as <strong>${this.email}</strong>, which doesn't have staff access.`
                            : nothing
                    }
                    Sign out and back in with a staff account to continue.
                </p>
                <button class="btn btn-primary" @click=${() => authState.logout()}>Sign out</button>
            </div>
        `;
    }
}

customElements.define('d3-not-authorized-view', NotAuthorizedView);
